import { useMatch } from 'react-router';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import InternalErrorState from '@/features/app/InternalErrorState';
import { useFetchBatteryPackLevelsQuery } from '@/features/battery/api/batterySlice';
import { PackLevelOverview } from '@/features/battery/workshop/PackLevelOverview';
import { LoadingScreen } from '@/features/batteryOverview/utils/BatteryDataUtils';

const PackLevelOverviewPage = () => {
    const assetId = useMatch('/dialog/pack-levels/:assetId')?.params.assetId;
    const { isLoading, isError, error, data: batteryPackResponse, refetch } = useFetchBatteryPackLevelsQuery(assetId!);

    if (isLoading) {
        return <LoadingScreen />;
    }
    if (isError) {
        return (
            <InternalErrorState
                errorCode={(error as FetchBaseQueryError).status as number}
                reloadTriggerFunction={refetch}
            />
        );
    }

    if (!batteryPackResponse) {
        return null;
    }

    return <PackLevelOverview batteryPackResponse={batteryPackResponse} />;
};

export default PackLevelOverviewPage;
